import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { SimpleForm, TextInput } from 'react-admin';
import { requestResolve as requestResolveAction } from '../actions/requestActions';
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import { Request, ValidationErrors } from '../../types';

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & {
    open: boolean;
    record: Request;
    onClose: () => void;
};

type State = {
    comment: string;
};

const validate = values => {
    const errors: ValidationErrors = {};
    if (values.comment == '' || values.comment == null) {
        errors.comment = ['Resolution is required'];
    }
    return errors;
};

class RequestResolve extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
        };
    }

    render() {
        const { record, requestResolve, open, onClose } = this.props;

        return (
            <Dialog fullWidth maxWidth="sm" open={!!open} onClose={onClose}>
                <DialogTitle>Resolve Dispute</DialogTitle>
                <SimpleForm toolbar={null} validate={validate}>
                    <TextInput
                        fullWidth
                        multiline
                        source="comment"
                        label="Resolution"
                        onChange={e =>
                            this.setState({ comment: e.target.value })
                        }
                    />

                    <DialogActions>
                        <Button onClick={onClose}>Close</Button>
                        <Button
                            disabled={!this.state.comment}
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                requestResolve(record.id, {
                                    ...record,
                                    comment: this.state.comment,
                                });
                                validate({ comment: this.state.comment });
                                onClose();
                            }}
                        >
                            Resolve Dispute
                        </Button>
                    </DialogActions>
                </SimpleForm>
            </Dialog>
        );
    }
}

const mapDispatch = {
    requestResolve: requestResolveAction,
};

const connector = connect(null, mapDispatch);

export default connector(RequestResolve);
